import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import { selectLoggedIn } from '../store/slice/auth/slice';
import { selectUserInfo } from '../store/slice/vendor/slice';

function AuthLayout() {
  const navigate = useNavigate();
  const isAuthenticated = useSelector(selectLoggedIn);
  const { onboardingFinishedAt } = useSelector(selectUserInfo);

  useEffect(() => {
    if (isAuthenticated && onboardingFinishedAt) {
      navigate({
        pathname: '/clients',
      });
    } else if (isAuthenticated && !onboardingFinishedAt) {
      navigate({
        pathname: '/sign-up',
        search: `?step=1`,
      });
    }
  }, [isAuthenticated, navigate, onboardingFinishedAt]);

  return <Outlet />;
}

export default AuthLayout;
